import { service } from '@ember/service';
import { tracked } from '@glimmer/tracking';
import Component from '@glimmer/component';
import type { EmployeeExtension as EmployeeModel } from 'tio-data/data/resources/employee.ext';
import PslfAdminProfileEmployeeFormsTable from '../pslf/admin/profile/employee-forms-table.gts';
import type Owner from '@ember/owner';
import { Section } from 'tio-ui/components/layout';

import type SessionContextService from '../../services/session-context.ts';
export interface ProfilePslfSignature {
  Args: {
    employee: EmployeeModel;
    isPartner?: boolean;
    limit?: number;
  };
  Element: HTMLElement;
}

export default class ProfilePslfComponent extends Component<ProfilePslfSignature> {
  @service declare sessionContext: SessionContextService;

  @tracked count: number = 0;
  limit: number = 10;

  constructor(owner: Owner, args: ProfilePslfSignature['Args']) {
    super(owner, args);
    this.limit = this.args.limit || this.limit;
  }

  <template>
    <Section>
      <:header>PSLF Forms</:header>
      <:body>
        <PslfAdminProfileEmployeeFormsTable
          @limit={{this.limit}}
          @employee={{@employee}}
          @isTioAdmin={{this.sessionContext.user.isTioAdmin}}
        />
      </:body>
    </Section>
  </template>
}
